const ICON_MINIMIZE_RAW = ({ color = "#000", strokeWidth = 1, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" {...props}>
    <path
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeWidth={0.9}
      d="M.452 6h3.547v3.548M9.55 3.997H6.003V.45"
      style={{
        paintOrder: "markers fill stroke",
      }}
    />
  </svg>
);

export default ICON_MINIMIZE_RAW;
